const userAgent = navigator.userAgent;

export const isAndroid = /Android/i.test(userAgent);
export const isIOS =
  /iPhone|iPad|iPod/i.test(userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isMobile = isAndroid || isIOS;
